import React from 'react';


const SuccessIcon = () => {

  return (
    <svg viewBox="0 0 41 41" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>Group 2</title>
        <desc>Created with Sketch.</desc>
        <g id="Version-1.8---End-to-end" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
            <g id="FTTH-/-WEB---Manage-fibre_NameSave-Copy-2" transform="translate(-139.000000, -89.000000)" stroke="#428600" strokeWidth="3">
                <g id="Group-2" transform="translate(141.000000, 91.000000)">
                    <circle id="fa6b6f14-96c8-4460-a558-d4de6594186a" cx="18.5" cy="18.5" r="18.5"></circle>
                    <polyline id="Path" strokeLinejoin="round" points="27 13 14.5383395 24 9 19.1112667"></polyline>
                </g>
            </g>
        </g>
    </svg>
  );
}



export default SuccessIcon;